export enum FloorCeiling {
  Floor = 'Floor',
  Ceiling = 'Ceiling',
}
